import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
/*import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';*/
import RadioValidatorElementFees from '../../Utility/RadioValidatorElementFees';

const styles = (theme: Theme) => createStyles({
    emtpy: {},
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonItem: {
        marginTop: theme.spacing(2),
    },
    button: {
    },
    multiSelect: {
        marginLeft: "10px"
    }
});

interface IRuleSetQuestionProps {
    handleQuestionChange: (event, newQuestionState) => void;
    setDisabled: () => void;
    value: boolean | undefined;
    name: string;
    question: string;
    falseQuestionState: number;
    trueQuestionState: number;
    disabled: boolean;
}

interface IRuleSetQuestionState {


}

export class EnrolmentForm extends Component<IRuleSetQuestionProps & WithStyles<typeof styles>, IRuleSetQuestionState> {

    constructor(props) {
        super(props);

    }

    public componentDidMount() {


    }

    private handleRadioChange = (event) => {
        var newState = event.target.value === 'true' ? this.props.trueQuestionState : this.props.falseQuestionState;
        this.props.handleQuestionChange(event, newState);
        this.props.setDisabled();
    }

    public render() {
        var classes = this.props.classes;
        return (
            <React.Fragment>
                <div className={classes.emtpy}></div>

                <RadioValidatorElementFees
                    falseLabel="No"
                    trueLabel="Yes"
                    name={this.props.name}
                    value={this.props.value}
                    question={this.props.question}
                    handleChange={this.handleRadioChange}
                    validators={['required']}
                    errorMessages={['This field is required']}
                    readOnly={this.props.disabled}
                />


            </React.Fragment>
        )
    }


}

export default withStyles(styles)(EnrolmentForm);